// Formas tiradas do próprio material: patinhas, ossinhos, notas musicais e nuvens do logo;
// laços, gravatinhas e bandanas que os pets usam nas fotos pós-banho.

export const Paw = ({ className, style, title }) => (
  <svg viewBox="0 0 512 512" className={className} style={style} fill="currentColor" aria-hidden={!title} role={title ? 'img' : undefined}>
    {title && <title>{title}</title>}
    <path d="M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.16 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.16-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z" />
  </svg>
);

/** Laço de cabeça (como o dos pets de pelo longo e do Yorkshire) */
export const Bow = ({ className, style }) => (
  <svg viewBox="0 0 120 80" className={className} style={style} aria-hidden="true">
    <path d="M60 40 C 44 18, 14 6, 8 22 C 3 36, 18 58, 60 40 Z" fill="currentColor" />
    <path d="M60 40 C 76 18, 106 6, 112 22 C 117 36, 102 58, 60 40 Z" fill="currentColor" />
    <path d="M60 40 C 48 52, 38 70, 30 76 L 44 78 C 52 66, 58 52, 60 40 Z" fill="currentColor" opacity="0.85" />
    <path d="M60 40 C 72 52, 82 70, 90 76 L 76 78 C 68 66, 62 52, 60 40 Z" fill="currentColor" opacity="0.85" />
    <path d="M22 24 C 30 22, 44 28, 52 36" stroke="rgba(255,255,255,.55)" strokeWidth="3" fill="none" strokeLinecap="round" />
    <path d="M98 24 C 90 22, 76 28, 68 36" stroke="rgba(255,255,255,.55)" strokeWidth="3" fill="none" strokeLinecap="round" />
    <ellipse cx="60" cy="40" rx="11" ry="12" fill="currentColor" />
    <ellipse cx="60" cy="40" rx="11" ry="12" fill="rgba(0,0,0,.14)" />
  </svg>
);

/** Gravatinha borboleta (como a gravata listrada e a de bolinhas das fotos) */
export const BowTie = ({ className, style, dots = false }) => (
  <svg viewBox="0 0 120 64" className={className} style={style} aria-hidden="true">
    <path d="M60 32 L 10 6 C 3 3, 0 8, 0 14 L 0 50 C 0 56, 3 61, 10 58 Z" fill="currentColor" />
    <path d="M60 32 L 110 6 C 117 3, 120 8, 120 14 L 120 50 C 120 56, 117 61, 110 58 Z" fill="currentColor" />
    {dots && (
      <g fill="rgba(255,255,255,.65)">
        <circle cx="18" cy="20" r="4" /><circle cx="30" cy="40" r="4" /><circle cx="14" cy="46" r="3" />
        <circle cx="102" cy="20" r="4" /><circle cx="90" cy="40" r="4" /><circle cx="106" cy="46" r="3" />
      </g>
    )}
    <rect x="48" y="18" width="24" height="28" rx="8" fill="currentColor" />
    <rect x="48" y="18" width="24" height="28" rx="8" fill="rgba(0,0,0,.16)" />
  </svg>
);

export const Bone = ({ className, style }) => (
  <svg viewBox="0 0 512 256" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M100 40c-33 0-60 27-60 60 0 12 4 23 10 32-6 9-10 20-10 32 0 33 27 60 60 60 30 0 54-22 59-50h194c5 28 29 50 59 50 33 0 60-27 60-60 0-12-4-23-10-32 6-9 10-20 10-32 0-33-27-60-60-60-30 0-54 22-59 50H159c-5-28-29-50-59-50z" />
  </svg>
);

export const Note = ({ className, style }) => (
  <svg viewBox="0 0 64 80" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M24 8 L 60 0 L 60 56 C 60 66, 51 72, 42 72 C 34 72, 28 67, 28 60 C 28 52, 36 47, 44 47 C 47 47, 50 48, 52 49 L 52 16 L 32 20 L 32 64 C 32 74, 23 80, 14 80 C 6 80, 0 75, 0 68 C 0 60, 8 55, 16 55 C 19 55, 22 56, 24 57 Z" />
  </svg>
);

export const Cloud = ({ className, style }) => (
  <svg viewBox="0 0 200 100" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M46 96 C 20 96, 4 82, 4 64 C 4 46, 20 34, 38 36 C 42 16, 60 4, 82 4 C 104 4, 120 16, 126 34 C 134 28, 144 26, 154 28 C 176 32, 194 48, 194 68 C 194 84, 180 96, 160 96 Z" />
  </svg>
);

export const Sparkle = ({ className, style }) => (
  <svg viewBox="0 0 48 48" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M24 0 C 26 14, 34 22, 48 24 C 34 26, 26 34, 24 48 C 22 34, 14 26, 0 24 C 14 22, 22 14, 24 0 Z" />
  </svg>
);

export const WhatsAppIcon = ({ className, style }) => (
  <svg viewBox="0 0 32 32" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.1.56 4.16 1.62 5.97L4 29l8.27-1.58a12.1 12.1 0 0 0 3.77.6C22.68 28.02 28 22.66 28 16.05 28 9.44 22.68 3 16.04 3Zm0 22.9c-1.2 0-2.38-.2-3.5-.6l-.25-.09-4.9.94.97-4.74-.16-.26a9.8 9.8 0 0 1-1.52-5.18c0-5.43 4.42-9.84 9.36-9.84 5.4 0 9.8 4.94 9.8 10.02 0 5.4-4.4 9.75-9.8 9.75Zm5.37-7.3c-.3-.15-1.74-.86-2-.95-.28-.1-.47-.15-.67.15-.2.29-.77.95-.94 1.14-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.47-1.75-1.64-2.04-.17-.3-.02-.45.13-.6.13-.13.3-.34.44-.51.15-.17.2-.3.3-.49.1-.2.05-.37-.02-.51-.08-.15-.67-1.6-.92-2.2-.24-.57-.48-.5-.67-.5h-.57c-.2 0-.51.07-.78.36-.27.3-1.03 1-1.03 2.44 0 1.43 1.05 2.82 1.2 3.02.15.19 2.07 3.15 5.01 4.42.7.3 1.25.48 1.68.62.7.22 1.35.19 1.85.12.57-.08 1.74-.71 1.99-1.4.24-.68.24-1.27.17-1.39-.07-.12-.27-.2-.56-.34Z" />
  </svg>
);

export const InstagramIcon = ({ className, style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.4" cy="6.6" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const ArrowUpRight = ({ className, style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M7 17 17 7M8 7h9v9" />
  </svg>
);

export const Heart = ({ className, style }) => (
  <svg viewBox="0 0 512 512" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" />
  </svg>
);

export const Star = ({ className, style }) => (
  <svg viewBox="0 0 576 512" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
  </svg>
);

/** Rabisco desenhado à mão (sublinhado ondulado) */
export const Squiggle = ({ className, style }) => (
  <svg viewBox="0 0 200 20" className={className} style={style} fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" aria-hidden="true">
    <path d="M4 12 C 20 2, 30 2, 44 11 S 70 20, 84 11 S 110 2, 124 11 S 150 20, 164 11 S 186 4, 196 9" />
  </svg>
);

/** Setinha desenhada à mão */
export const DoodleArrow = ({ className, style }) => (
  <svg viewBox="0 0 90 60" className={className} style={style} fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6 8 C 20 44, 46 52, 78 40" />
    <path d="M66 30 L 80 40 L 64 50" />
  </svg>
);

export const Cloudy = ({ className, style }) => (
  <svg viewBox="0 0 120 64" className={className} style={style} fill="currentColor" aria-hidden="true">
    <path d="M30 62 C 14 62, 2 52, 2 40 C 2 28, 12 20, 24 20 C 28 8, 40 2, 52 2 C 66 2, 78 10, 82 22 C 86 20, 90 19, 94 19 C 108 19, 118 29, 118 41 C 118 53, 108 62, 94 62 Z" />
  </svg>
);
